
import { Map } from 'immutable';
import {
    GET_DEPSTRADDRESS, SET_POST_ADDRESS, SET_PRIOR_ADDRESS,
} from '../actions/dependentStreetAddressStore';

const defaultAddress = {
    AddressID: 0,
    StreetAddressAddressID: 0,
    AddressSubTypeID: 0,
    ConcurrencyCheck: [],
    StreetAddressLine1: "",
    StreetAddressLine2: null,
    StreetAddressLine3: null,
    StreetAddressConcurrencyCheck: [],
    IsPrimaryContact: false,
    StreetAddressPostCode: "",
    StreetAddressCity: "",
    StreetAddressState: "",
    StreetAddressCountry: "Australia",
    StreetAddressLatitude: 0,
    StreetAddressLongitude: 0,
    IsValidated: true,
    StreetAddressSubTypeID: 0,
    CurrentState: 0
}

const initialState = Map({
    dependentStreet: defaultAddress,
    priorEnlistmentAddress: defaultAddress,
    postEnlistmentAddress: defaultAddress
});

const actionsMap = {
    [GET_DEPSTRADDRESS]: (state, action) => {
        return state.set('dependentStreet', action.data);
    },
    [SET_PRIOR_ADDRESS]: (state, action) => {
        return state.set('priorEnlistmentAddress', action.data);
    },
    [SET_POST_ADDRESS]: (state, action) => {
        return state.set('postEnlistmentAddress', action.data);
    },
};

export default function facilities(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}
